import { render } from "./CreatSubscription.vue?vue&type=template&id=7e857f93"
import script from "./CreatSubscription.vue?vue&type=script&lang=js"
export * from "./CreatSubscription.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/localhost/storage/app/public/maskansazangolchin-site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__